import ElementUI from "element-ui";
import store from "../vuex/index.js";
var MUIUtil = {
  /**
   * 筛选出树形子节点的id
   *
   * arr: 传进来的树形数组
   * data：所有的树形数组列表
   * idName:主键id
   * childsName:子集名称
   */
  screenNode: function(arr, data, idName, childsName) {
    var newArr = [];
    arr.forEach(function(item) {
      MUIUtil.checked(item, data, newArr, idName, childsName);
    });
    return newArr;
  },
  checked: function(id, data, newArr, idName, childsName) {
    var _this = this;
    data.forEach(item => {
      if (item[idName] == id) {
        if (item[childsName] == null || item[childsName].length == 0) {
          newArr.push(item[idName]);
        }
      } else {
        if (item[childsName] != null && item[childsName].length != 0) {
          MUIUtil.checked(id, item.childNodes, newArr, idName, childsName);
        }
      }
    });
  },

  /**
   * 关闭当前页面
   * pageName: 页面名称
   * router : 当前路由
   */
  closePage: function(pageName, router) {
    store.commit("addExcludedComponents", pageName);
    for (let i = 0; i < store.getters.tabnavBox.length; i++) {
      if (store.getters.tabnavBox[i].title == pageName) {
        let tabItem = store.getters.tabnavBox[i];
        // fullPath匹配路由
        store.dispatch("removeTab", {
          tabItem,
          fullPath: router.fullPath,
          router: router
        });
      }
    }
  },

  /**
   * 表单验证
   * 满足验证要求返回true，否者返回false
   */
  validForm: function(formData, rules) {
    //验证结果记录
    var result = true;
    //循环校验表单
    for (var key in formData) {
      var value = formData[key];
      var ruleObj = rules[key];
      //跳过没有设置验证规则的属性
      if (!ruleObj) {
        continue;
      }

      var rule = ruleObj.rule;
      var errmsg = ruleObj["errmsg"];

      if (!rule.test(value)) {
        ElementUI.Message({
          message: errmsg,
          type: "error"
        });
        result = false;
        break;
      }
    }
    //返回校验结果
    return result;
  }
};
export default MUIUtil;



// WEBPACK FOOTER //
// ./src/utils/MUIUtil.js